"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const WidgetError_1 = require("../Error/WidgetError");
/**
 * Compiler pass for linking parented services.
 */
class ParentServiceCompilerPass {
    /**
     * @inheritDoc
     */
    process(container) {
        container.getDefinitions().forEach((definition) => {
            if (!definition.getParent()) {
                return;
            }
            const parent = container.getDefinition(definition.getParent());
            if (!parent) {
                throw new WidgetError_1.default(`Unknown parent service '${definition.getParent()}' for service '${definition.getId()}'.`);
            }
            definition.setArguments(parent.getArguments().concat(definition.getArguments()));
        });
    }
}
exports.default = ParentServiceCompilerPass;
